import { MapPin, Building2 } from "lucide-react";
import { ConnectReveal } from "./ConnectReveal";
import { CATEGORY_LABELS } from "./categories";

const Side = ({ post, isNeed, testPrefix }) => (
  <div className={`p-5 sm:p-6 flex flex-col ${isNeed ? "bg-[#00F0FF]/[0.03]" : "bg-[#8A2BE2]/[0.05]"}`}>
    <div className="flex items-center justify-between gap-3">
      <span
        className={`font-mono-accent text-[10px] font-bold uppercase tracking-[0.25em] px-2.5 py-1 border ${
          isNeed ? "text-[#00F0FF] border-[#00F0FF]/40 bg-[#00F0FF]/5" : "text-[#B57BEE] border-[#8A2BE2]/50 bg-[#8A2BE2]/10"
        }`}
      >
        {isNeed ? "Need" : "Offer"}
      </span>
      <span className="font-mono-accent text-[10px] tracking-[0.18em] text-slate-600 uppercase truncate max-w-[46%]">
        {CATEGORY_LABELS[post.category] || post.category}
      </span>
    </div>
    <p className="mt-4 text-slate-200 text-sm leading-relaxed flex-1">{post.description}</p>
    <div className="mt-5 space-y-2">
      <div className="flex items-center gap-2.5 text-sm text-slate-300">
        <Building2 size={13} className="text-slate-600 shrink-0" />
        <span className="truncate">{post.name}</span>
      </div>
      <div className="flex items-center gap-2.5 text-sm text-slate-500">
        <MapPin size={13} className="text-slate-600 shrink-0" />
        <span className="truncate">{post.location}</span>
      </div>
    </div>
    <div className="mt-5">
      <ConnectReveal postId={post.id} isNeed={isNeed} testPrefix={testPrefix} />
    </div>
  </div>
);

export const MatchCard = ({ match }) => (
  <div
    className="p-px bg-[linear-gradient(135deg,rgba(0,240,255,0.45),rgba(138,43,226,0.45))]"
    data-testid={`match-card-${match.id}`}
  >
    <div className="bg-[#080B12] h-full">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 px-5 sm:px-6 py-4 border-b border-white/10">
        <span className="flex items-center gap-2.5" data-testid={`match-label-${match.id}`}>
          <span
            className="font-display font-extrabold text-lg leading-none text-transparent bg-clip-text"
            style={{ backgroundImage: "linear-gradient(92deg, #00F0FF 10%, #8A2BE2 90%)" }}
          >
            ✕
          </span>
          <span className="font-display font-extrabold uppercase tracking-wide text-slate-100 text-sm sm:text-base">
            Match Found
          </span>
        </span>
        <span className="font-mono-accent text-[10px] font-bold tracking-[0.2em] text-[#00F0FF] border border-[#00F0FF]/40 bg-[#00F0FF]/5 px-2.5 py-1" data-testid={`match-score-${match.id}`}>
          {match.score}% MATCH
        </span>
      </div>
      {match.reason && (
        <p className="px-5 sm:px-6 pt-4 font-mono-accent text-[10px] sm:text-[11px] tracking-[0.12em] text-slate-500 uppercase" data-testid={`match-reason-${match.id}`}>
          {match.reason}
        </p>
      )}
      <div className="grid sm:grid-cols-2 gap-px bg-white/10 mt-4 border-t border-white/10">
        <Side post={match.need} isNeed testPrefix="match-need" />
        <Side post={match.offer} isNeed={false} testPrefix="match-offer" />
      </div>
    </div>
  </div>
);
